/* eslint-disable eqeqeq */
import * as React from "react"
import { Box, Flex } from "@chakra-ui/react"
import { useRecoilValue, useRecoilState, useSetRecoilState } from "recoil"
import { SDKContext } from "../../../context/SDKContext"
import { watchPartyScreenLinkSelector } from "../../../recoil/atoms/watchPartyScreen"
import { LeaveOverlay } from "../leave-overlay"
import { FullScreen, useFullScreenHandle } from "react-full-screen"
import {
  watchPartyLoopStatusAtom,
  watchPartyHideControlsSelector
} from "../../../recoil/atoms/watchPartyScreen"
import { useLocalUserType } from "../../../hooks/useLocalUserType"
import { localUserIdAtom } from "../../../recoil/atoms/users"
import { useBrowserType } from "../../../hooks/useBrowserType"
import {
  useWatchParty,
  useWatchPartyController
} from "../../../hooks/useWatchParty"
import layoutStates from "../../../recoil/atoms/layout"
import { pipParamsSelector } from "../../../recoil/atoms/pictureInPicture"
import PiPBgBox from "../../common/pipBgBox"
import {
  brandingSelector,
  showTabsAtBottomOnMobileSelector
} from "../../../recoil/atoms/room"
import { LogoOverlay } from "../logo-overlay"
import { VideoContainer } from "./custom-player.styled"
import { EmotionalIcons } from "../buttons-main-screen/emotional-icons"
import { FullScreenIcon } from "../buttons-main-screen/full-screen-icon"
import {
  playerPropsSelector,
  currentTimeSelector,
  currentTimeMNPSelector,
  autoPlayMNPAtom,
  isPlayerVisibleAtom
} from "../../../recoil/atoms/player"
import { waitForElm } from "../../../util/waitForElm"
import { isBigPlayIconState } from "../../../recoil/atoms/bigPlayIcon"
import {
  auctionParamsSelector,
  auctionFinalResultAtom
} from "../../../recoil/atoms/auction"
import { AuctionOverlayBid } from "../../servicesPanel/auctions/auction-overlay-bid"
import { AuctionFinalOverlay } from "../../servicesPanel/auctions/auction-final-overlay"
import { OverlayNoPresentImage } from "./overlay-no-present-image"
import { FullScreenPlayerControlButton } from "./controls-player/fullscreen-player-button"
import { PlayerTime } from "./controls-player/time"
import { VideoPlayerProps } from "./custom-player.interface"
import { PlayerVolume } from "./controls-player/volume"
import { MuteButtonPlayer } from "./controls-player/mute-button"
import { PlayPauseButton } from "./controls-player/play-pause-button"
import { PlayerOverlay } from "./controls-player/player-overlay"
import { InformationOverlay } from "./information-overlay"

import { BarPlayer } from "./controls-player/bar-player"
import fullscreenState from "../../../recoil/atoms/fullscreen"
import {
  locationOfProductPageAtom,
  productOverlaySelector
} from "../../../recoil/atoms/product-overlay"
import {
  GAP_BETWEEN_OVERLAY_AND_BOTTOM_EDGE,
  IS_ANDROID_NATIVE_APP
} from "../../../constants"
import { PRODUCT_DESTINATION } from "../../../constants/enums"
import { ProductSelectorSizeOverlayType } from "../../servicesPanel/badges/product-selector/types"
import RainbowSpinner from "../../common/rainbowSpinner"
import { v4 as uuidv4 } from "uuid"
import { shoppableMNPVideoAtom } from "../../../recoil/atoms/shoppableVideos"
import {
  localMuteAtom,
  wpLocalMuteControlPropsAtom
} from "../../../recoil/atoms/local-mute"
import { ProductOverlay } from "../../servicesPanel/badges/product-selector/overlay-product"
import { detectSafariDesktop } from "../../../util/deviceType"
import wpDefaultSrc from "../../../assets/media/samplevideo.mp4"
import { connectionStatusAtom } from "../../../recoil/atoms/connectionStatus"
import { ConnectionStatus, ModNotPresentType } from "../../../constants/enums"
import { LeaveMeetingButton } from "../leave-overlay"
import DragToResizeIcon from "./controls-player/drag-to-resize-icon"
import PlayerPanel from "./controls-player/player-panel"
import { checkIsModNotPresentId } from "../../../util"
import { showRHSLeaveButtonSelector } from "../../../recoil/selectors/layoutSelectors/layout-selectors"
import useLocalSpeakerMute from "../../../hooks/multimedia/useLocalSpeakerMute"
import { LocalMuteIcon } from "../buttons-main-screen/local-mute-icon"
import { ShareLinksModal } from "../share-links-modal"
import { shareLinksModalAtom } from "../../../recoil/atoms/layout/share-links-modal"
import { useFullScreenMobile } from "../../../hooks/useFullScreenMobile"
import useIsVideo from "src/components/servicesPanel/chat/utils/useIsVideo"
import FloatingControls, { FloatingControlsCtx } from "../floatingControls"
import { CircleCloseIcon } from "src/components/common/icons"
import { useVideoPopup } from "../floating-container/useVideoPopup"
import {
  previouslyPublishedChat,
  updateChatSelector
} from "src/recoil/atoms/chats"
import { MessageModel } from "src/recoil/atoms/chats/types"

declare global {
  interface Document {
    exitFullscreen: () => Promise<void>
    mozCancelFullScreen: any
    webkitExitFullscreen: any
    fullscreenElement: any
    mozFullScreenElement: any
    webkitFullscreenElement: any
    msExitFullscreen: any
    msFullscreenElement: any
  }

  interface HTMLVideoElement {
    webkitEnterFullScreen: any
  }
}

export const VideoPlayer: React.FC<VideoPlayerProps> = React.memo(
  ({
    styling,
    showLeave,
    isMobile,
    isTouchDelay,
    isLandscape,
    isFullScreen,
    isTransparent,
    overlay,
    header,
    maxHeightMainScreen,
    overlayWidth,
    isSmallMainScreen,
    maxWidthOverlay,
    showLeaveOverlay,
    setShowLeaveOverlay,
    widthLeaveOverlay,
    isTablet,
    widthMainScreen,
    isMediumAuctionBadge,
    isMainMobileScreen,
    localUserProperties,
    isLogo,
    isBorderVideoPlayer,
    heightLeaveOverlay,
    hideSpinner,
    isWithoutTitle,
    isUrlBarNarrowed,
    isDesktop,
    showFullscreenPlayerButtons,
    changeSizeIconDependingHeightVideo
  }) => {
    const meetingClient = React.useContext(SDKContext)
    const setHideLeaveButton = useSetRecoilState(layoutStates.hideLeaveButton)
    const setTabletFullScreen = useSetRecoilState(
      fullscreenState.isTabletFullScreen
    )
    const [wpLocalMuteControlProps, setWpLocalMuteControlProps] =
      useRecoilState(wpLocalMuteControlPropsAtom)
    const { enabledShoppableMNP, srcShoppableMNP, typeShoppableMNP } =
      useRecoilValue(shoppableMNPVideoAtom)

    const setShowOnVideoOverlayContent = useSetRecoilState(
      layoutStates.showOnVideoOverlayContent
    )

    const { isSafariMobile, isIOSIpad, isSafariDesktop } = useBrowserType()

    const {
      isHost,
      isWatchParty,
      watchPartyHostId,
      isAudioWatchParty,
      isModPresentVideo,
      isModPresentImage,
      watchPartyType
    } = useWatchParty()
    const [isSpinner, setSpinner] = React.useState(true)
    const [{ isOpen }, setProductOverlay] = useRecoilState(
      productOverlaySelector
    )
    const [isAutoPlayMNP, setAutoPlayMNP] = useRecoilState(autoPlayMNPAtom)
    const { isModalBid } = useRecoilValue(auctionParamsSelector)
    const { isFinalModal } = useRecoilValue(auctionFinalResultAtom)
    const [isBigPlayIcon, setBigPlayIcon] =
      useRecoilState<boolean>(isBigPlayIconState)
    let wpSrc = useRecoilValue(watchPartyScreenLinkSelector)
    const { isVideo, isBase64 } = useIsVideo(wpSrc)
    const { isActivePiP, coverImage } = useRecoilValue(pipParamsSelector)
    const [isLoop] = useRecoilState(watchPartyLoopStatusAtom)
    const hideControls = useRecoilValue(watchPartyHideControlsSelector)
    const { isModerator } = useLocalUserType()
    const setPiPParams = useSetRecoilState(pipParamsSelector)
    const playerRef = React.useRef(null)
    const [values, setValues] = React.useState([0])
    const [isPlayerFocused, setPlayerIsFocused] =
      useRecoilState(isPlayerVisibleAtom)
    const { toggleVideoPopup, isAvatarPopupActive } = useVideoPopup()
    const { stopWatchParty } = useWatchPartyController()

    const {
      muted,
      paused,
      volume,
      isControlVolume,
      isOpenControlsMobile,
      isOpenControlDesktop,
      isEnabledToggleControlDesktop,
      isMNPLastTime,
      isEnabledAutoPlay
    } = useRecoilValue(playerPropsSelector)
    const keepLeaveOverlayActive = useRecoilValue(
      layoutStates.keepLeaveOverlayActive
    )

    const isFloatingDivActive = useRecoilValue(layoutStates.isFloatingDivActive)
    const currentTimeProps = useRecoilValue(currentTimeSelector)
    const currentTimeMNPProps = useRecoilValue(currentTimeMNPSelector)
    const setСurrentTimeMNP = useSetRecoilState(currentTimeMNPSelector)
    const setСurrentTime = useSetRecoilState(currentTimeSelector)
    const setPlayerProps = useSetRecoilState(playerPropsSelector)
    /* const activeSpeaker = useRecoilValue(activeSpeakerSelector)
    const mainWindowUser = useRecoilValue(mainWindowUserSelector) */
    const showLeaveButtonOnRHS = useRecoilValue(showRHSLeaveButtonSelector)
    const [isLocalMuted, setLocalMuted] = useRecoilState(localMuteAtom)
    const productPageLocation = useRecoilValue(locationOfProductPageAtom)

    // Field needed for reconnection
    const videoErrorRef = React.useRef<boolean>(null)
    const videoPrevCurrentTimeRef = React.useRef<number>(null)
    const connectionStatus = useRecoilValue(connectionStatusAtom)
    const showTabsAtBottomOnMobile = useRecoilValue(
      showTabsAtBottomOnMobileSelector
    )
    const showShareLinksModal = useRecoilValue(shareLinksModalAtom)

    const { toggleLocalSpeaker, muteLocalSpeaker } = useLocalSpeakerMute()
    const video = document.getElementById(
      "watchpartyvideoplayer"
    ) as HTMLVideoElement

    const currentTimeElement = document.getElementById(
      "custom-player-current-time"
    ) as HTMLSpanElement
    const durationTimeElement = document.getElementById(
      "custom-player-duration-time"
    ) as HTMLSpanElement

    const isMuted = React.useMemo(() => {
      return wpLocalMuteControlProps.enabled
        ? wpLocalMuteControlProps.value
        : isLocalMuted // video?.muted // isLocalMuted  //
    }, [
      // isHost,
      wpLocalMuteControlProps.enabled,
      wpLocalMuteControlProps.value,
      // video?.muted,
      isLocalMuted
    ])

    React.useEffect(() => {
      if (!playerRef.current) return

      console.log("Pausing..")
      if (paused) {
        playerRef.current.pause()
      } else {
        playerRef.current.play()
      }
    }, [paused])

    const handlePlayPlayerAutomatically = React.useCallback(async () => {
      const player = (await waitForElm(
        "watchpartyvideoplayer"
      )) as HTMLVideoElement

      const currentTime = await currentTimeProps.handleReturnData()

      player.currentTime = currentTime
      player.muted = muted
      player.volume = volume
      player.play()
    }, [currentTimeProps, muted, volume])

    const handlePausePlayerAutomatically = React.useCallback(async () => {
      const player = (await waitForElm(
        "watchpartyvideoplayer"
      )) as HTMLVideoElement

      const currentTime = await currentTimeProps.handleReturnData()
      player.currentTime = currentTime
      player.muted = isLocalMuted // isMuted
      player.volume = volume
    }, [
      currentTimeProps,
      // muted,
      volume,
      isLocalMuted
    ])

    const returnMNPLastCurrentTime = async () => {
      const player = (await waitForElm(
        "watchpartyvideoplayer"
      )) as HTMLVideoElement

      const lastCurrentTime = await currentTimeMNPProps.handleReturnData()
      player.currentTime = lastCurrentTime.lastStopCurrentTime
      setPlayerProps({
        isMNPLastTime: false
      })
    }

    React.useEffect(() => {
      if (isMNPLastTime) {
        returnMNPLastCurrentTime()
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isMNPLastTime])

    React.useEffect(() => {
      if (
        isWatchParty &&
        isEnabledAutoPlay &&
        !paused &&
        paused !== undefined &&
        (watchPartyHostId === "modNotPresentVideo" ||
          watchPartyHostId === _localUserId)
      ) {
        if (!isActivePiP) {
          handlePlayPlayerAutomatically()
        }
      }

      if (
        isWatchParty &&
        isEnabledAutoPlay &&
        paused &&
        paused !== undefined &&
        (watchPartyHostId === "modNotPresentVideo" ||
          watchPartyHostId === _localUserId)
      ) {
        if (!isActivePiP) {
          handlePausePlayerAutomatically()
        }
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const playVideo = event => {
      event.stopPropagation()

      setBigPlayIcon(false)

      video.play()
      setPlayerProps({
        paused: false,
        isEnabledToggleControlDesktop: true,
        isEnabledAutoPlay: true
      })
      setShowLeaveOverlay(false)
    }

    const pauseVideo = e => {
      e.stopPropagation()
      video.pause()

      setPlayerProps({ paused: true, isEnabledAutoPlay: true })
      setShowLeaveOverlay(false)
    }

    // UseEffect to enable and disable wpLocalMuteControl
    React.useEffect(() => {
      if (isHost) {
        const value = { enabled: true, value: isMuted }
        setWpLocalMuteControlProps(value)
        meetingClient?.rtc?.toggleWpLocalMuteControl(value)
        meetingClient?.rtc?.toggleControlMute(false)
      } else {
        const value = { enabled: false, value: false }
        setWpLocalMuteControlProps(value)
        meetingClient?.rtc?.toggleWpLocalMuteControl(value)
      }
    }, [isHost])

    const handleMute = e => {
      e.stopPropagation()

      if (isHost) {
        // don't unmute if local speaker is mute
        if (!(video.muted && isLocalMuted)) {
          video.muted = !video.muted
        }

        setWpLocalMuteControlProps(prev => ({
          enabled: true,
          value: !wpLocalMuteControlProps.value
        }))
        meetingClient?.rtc?.toggleWpLocalMuteControl({
          enabled: true,
          value: !wpLocalMuteControlProps.value
        })
        // setPlayerProps({ muted: wpLocalMuteControlProps.value })
        return
      }

      toggleControlMute()
      toggleLocalSpeaker()
    }

    const handleOnChange = value => {
      // if duration is not an number
      if (isNaN(video?.duration)) return

      if (
        isMobile &&
        watchPartyHostId === "modNotPresentVideo" &&
        video.paused &&
        isLoop &&
        value[0] > 99.99
      ) {
        video.currentTime = (99.99 * video.duration) / 100
        setValues([99.99])
      } else {
        video.currentTime = (value * video.duration) / 100
        setValues(value)
      }
    }

    const handleOnMouseMoveVolume = e => {
      video.volume = e.target.value / 100
      setPlayerProps({ volume: video.volume })
    }

    if (wpSrc === "") {
      wpSrc = wpDefaultSrc
    }

    const [timeStamp, setTimeStamp] = React.useState({
      start: 0,
      end: 0
    })

    const isFullScreenMode = useFullScreenHandle()

    const touchDelay = isTouchDelay ? 100 : 150

    const controlPanelAutoHideTimerId = React.useRef(null)

    React.useEffect(() => {
      if (showLeaveOverlay && !keepLeaveOverlayActive) {
        controlPanelAutoHideTimerId.current = setTimeout(() => {
          setShowLeaveOverlay(false)
          setShowOnVideoOverlayContent(true)
          setHideLeaveButton(false)
          if (isEnabledToggleControlDesktop) {
            setPlayerProps({
              isOpenControlsMobile: false
            })
          } else {
            setPlayerProps({ isOpenControlsMobile: false })
          }
        }, 4000)
        return () => clearTimeout(controlPanelAutoHideTimerId.current)
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
      showLeaveOverlay,
      setShowLeaveOverlay,
      showLeave,
      keepLeaveOverlayActive
    ])

    const toggleShowLeaveOverlay = React.useCallback(
      e => {
        e.preventDefault()
        e.stopPropagation()
        if ((isMobile && !isTablet) || isOpen) {
          return
        }

        if (showLeave) {
          if (showLeaveOverlay) {
            if (isEnabledToggleControlDesktop) {
              setPlayerProps({
                isOpenControlsMobile: false
              })
            } else {
              setPlayerProps({ isOpenControlsMobile: false })
            }
          }
          if (!showLeaveOverlay) {
            if (isEnabledToggleControlDesktop) {
              setPlayerProps({
                isOpenControlsMobile: true
              })
            } else {
              setPlayerProps({ isOpenControlsMobile: true })
            }
          }
          setShowLeaveOverlay(!showLeaveOverlay)

          /* setPlayerProps({isOpenControlsMobile: !isOpenControlsMobile}) */
        }
      },
      [
        isEnabledToggleControlDesktop,

        isMobile,
        isOpen,
        isTablet,
        setPlayerProps,
        setShowLeaveOverlay,
        showLeave,
        showLeaveOverlay,
        setPlayerIsFocused,
        isPlayerFocused
      ]
    )

    const handleTouchStart = e => {
      e.preventDefault()
      e.stopPropagation()
      setTimeStamp({ ...timeStamp, start: e.timeStamp })
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const toggleControlMute = () => {
      meetingClient?.rtc?.toggleControlMute(false)
    }

    const handleOnTouchEndPlay = React.useCallback(
      async e => {
        e.preventDefault()
        e.stopPropagation()
        if (e.timeStamp - timeStamp.start < touchDelay) {
          video.play()

          setPlayerProps({ paused: false })
          setShowLeaveOverlay(false)
          let timer = setTimeout(() => {
            setPlayerProps({ isOpenControlsMobile: false })
          }, 3000)
          return () => clearTimeout(timer)
        }
        setTimeStamp({ start: 0, end: 0 })
      },
      [setPlayerProps, setShowLeaveOverlay, timeStamp.start, touchDelay, video]
    )

    const handleOnTouchEndStop = React.useCallback(
      e => {
        e.preventDefault()
        e.stopPropagation()
        if (e.timeStamp - timeStamp.start < touchDelay) {
          video.pause()
          setPlayerProps({ paused: true })
          setShowLeaveOverlay(false)
        }
        setTimeStamp({ start: 0, end: 0 })
      },
      [setPlayerProps, setShowLeaveOverlay, timeStamp.start, touchDelay, video]
    )

    const handleOnTouchEndMute = React.useCallback(
      e => {
        if (e.timeStamp - timeStamp.start < touchDelay) {
          // video.muted = !video.muted
          toggleControlMute()
          // setPlayerProps({ muted: video.muted })
          toggleLocalSpeaker()

          let timer = setTimeout(() => {
            setPlayerProps({ isOpenControlsMobile: false })
          }, 3000)
          return () => clearTimeout(timer)
        }
        setTimeStamp({ start: 0, end: 0 })
      },
      [
        setPlayerProps,
        timeStamp.start,
        toggleControlMute,
        touchDelay,
        // video,
        toggleLocalSpeaker
      ]
    )

    const toggleShowLeaveOverlayTouchEnd = React.useCallback(
      e => {
        if (e.timeStamp - timeStamp.start < touchDelay && !isOpen) {
          if (showLeaveOverlay) {
            setPlayerProps({ isOpenControlsMobile: false })
          }
          if (!showLeaveOverlay) {
            setPlayerProps({ isOpenControlsMobile: true })
          }
          setShowLeaveOverlay(!showLeaveOverlay)
        }
        setTimeStamp({ start: 0, end: 0 })
      },
      [
        isOpen,
        setPlayerProps,
        setShowLeaveOverlay,
        showLeaveOverlay,
        timeStamp.start,
        touchDelay
      ]
    )
    const { handleFullScreenMobileWebCam, isInFullScreen } =
      useFullScreenMobile()

    const { isAndroidMobile } = useBrowserType()

    const toggleBigPlayButton = React.useCallback(() => {
      let timer = setTimeout(() => {
        setBigPlayIcon(true)
      }, 1000)
      return () => clearTimeout(timer)
    }, [setBigPlayIcon])

    const handleShowFullScreen = React.useCallback(() => {
      if (isFullScreenMode && isFullScreenMode?.active) {
        if (isTablet) {
          setTabletFullScreen(false)
        }
        isFullScreenMode.exit()
      } else {
        if (isTablet) {
          setTabletFullScreen(true)
        }
        if (isMobile) {
          if (!isAndroidMobile) {
            toggleBigPlayButton()
          }
          handleFullScreenMobileWebCam("watchpartyvideoplayer")
        } else {
          isFullScreenMode.enter()
        }
      }
    }, [
      isFullScreenMode,
      isInFullScreen,
      isTablet,
      setTabletFullScreen,
      isAndroidMobile
    ])

    const _localUserId = useRecoilValue(localUserIdAtom)

    const roomStyles = useRecoilValue(brandingSelector)
    const videoPlayer = document.getElementById(
      "watchpartyvideoplayer"
    ) as HTMLVideoElement

    const leavePictureinPicture = React.useCallback(async () => {
      setProductOverlay({ isOpen: false })

      const player = (await waitForElm(
        "watchpartyvideoplayer"
      )) as HTMLVideoElement

      if (player.paused === true) {
        setPlayerProps({ paused: true })
        if (watchPartyHostId === "modNotPresentVideo") {
          setBigPlayIcon(true)
        }
        setPiPParams({ isActivePiP: false })
      }

      if (player.paused === false) {
        setPlayerProps({ paused: false })
        setBigPlayIcon(false)
        setTimeout(() => {
          player.play()
        }, 1000)
        setPiPParams({ isActivePiP: false })
      }

      setPiPParams({ isActivePiP: false })
    }, [
      setBigPlayIcon,

      setPiPParams,
      setPlayerProps,
      setProductOverlay,
      watchPartyHostId
    ])

    React.useEffect(() => {
      if (videoPlayer) {
        videoPlayer.addEventListener(
          "leavepictureinpicture",
          leavePictureinPicture
        )
        return () => {
          videoPlayer.removeEventListener(
            "leavepictureinpicture",
            leavePictureinPicture
          )
        }
      }
    }, [leavePictureinPicture, videoPlayer])

    React.useEffect(() => {
      if (!isMobile) {
        controlPanelAutoHideTimerId.current = setTimeout(() => {
          if (!detectSafariDesktop()) {
            setPlayerProps({
              isOpenControlDesktop: false,
              isEnabledAutoPlay: true
            })
          }
        }, 4000)
        return () => clearTimeout(controlPanelAutoHideTimerId.current)
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    // This useEffect mute the watch control mute to false if, watch is active and local speaker was muted
    React.useEffect(() => {
      if (isWatchParty && isMuted && !isHost) {
        meetingClient?.rtc?.toggleControlMute(false)
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isWatchParty])

    React.useEffect(() => {
      const notMNPImageAndOverlay = ![
        ModNotPresentType.IMAGE,
        ModNotPresentType.OVERLAY
      ].includes(watchPartyHostId as any)
      // initial local mute state, if not initialled and not MNP Image and Overlay
      if (isLocalMuted === undefined && notMNPImageAndOverlay) {
        const initialMuteState =
          (isMobile && !isTablet) || isIOSIpad || isSafariDesktop ? true : false
        setLocalMuted(initialMuteState)

        if (initialMuteState) {
          // if the video is initially muted, do not hide the control panel.
          clearTimeout(controlPanelAutoHideTimerId.current)
        }
        if (initialMuteState) {
          // if muted, set watch party enabled
          muteLocalSpeaker() // mute the speaker
        }
      }

      setPlayerProps({
        paused:
          isAutoPlayMNP &&
          !isEnabledAutoPlay &&
          watchPartyHostId === "modNotPresentVideo"
            ? false
            : video?.paused,
        muted: isMobile && !isTablet ? true : isMuted
      })

      if (watchPartyHostId !== _localUserId) {
        setPlayerProps({
          isEnabledToggleControlDesktop: true

          /*  isEnabledAutoPlay: true */
        })
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    React.useEffect(() => {
      if (
        isMobile &&
        roomStyles?.enableModNotPresentOverlay &&
        watchPartyHostId === "modNotPresentImage"
      ) {
        setShowLeaveOverlay(true)
      }
    }, [
      isMobile,
      roomStyles?.enableModNotPresentOverlay,
      setShowLeaveOverlay,
      watchPartyHostId
    ])

    const isHiddenControl = React.useMemo(() => {
      if (watchPartyHostId === "modNotPresentVideo") {
        return false
      } else {
        return watchPartyHostId !== _localUserId ? true : false
      }
    }, [_localUserId, watchPartyHostId])

    const isVolumeScale = React.useMemo(() => {
      return !isMobile || isTablet
    }, [isTablet, isMobile])

    const productSelectorOverlaySizeProps =
      React.useMemo<ProductSelectorSizeOverlayType>(() => {
        return {
          height: isLandscape
            ? `${maxHeightMainScreen}px`
            : isTablet
            ? `calc(${maxHeightMainScreen}px - 5px)`
            : isMobile
            ? `calc(${maxHeightMainScreen}px - 0.5rem + 1px)`
            : `calc(${
                maxHeightMainScreen -
                7 -
                GAP_BETWEEN_OVERLAY_AND_BOTTOM_EDGE * (isTablet ? 1 : 2)
              }px - 1rem)`,
          width: isLandscape
            ? `${widthLeaveOverlay}`
            : isTablet
            ? `${widthMainScreen}px`
            : isMobile
            ? `calc(${widthMainScreen}px - 0.5rem + 1px)`
            : `calc(${widthMainScreen}px - 75px)`,
          isLargeMenu:
            (isWithoutTitle !== undefined
              ? !isWithoutTitle
              : +widthMainScreen - 90 > 700) && !isLandscape,
          isSmallMenu: +widthMainScreen - 90 < 450,
          isTablet: isTablet,
          isFullSizeOverlay: (isLandscape && isOpen) || (isMobile && isOpen),
          isLandscape
        }
      }, [
        isLandscape,
        isMobile,
        isOpen,
        isTablet,
        isWithoutTitle,
        maxHeightMainScreen,
        widthLeaveOverlay,
        widthMainScreen
      ])

    /*  const stylesModalProductOverlay = React.useMemo(() => {
      return {
        container: {
          display: !(isActivePiP && !isRedirected) ? "none" : "flex",
          height: `${maxHeightMainScreen}px`,
          width: `${widthMainScreen}px`,
          padding:isMobile && isLandscape
        ? "1.5rem 1rem 1.5rem 1rem"
        : isMobile && "0.5rem"
        }
      }
    }, [isActivePiP, isLandscape, isMobile, maxHeightMainScreen, widthMainScreen]) */

    // This method get called when error is occur while playing video
    const handleError = async event => {
      videoErrorRef.current = true
      setSpinner(true)
    }

    const handleTimeUpdate = () => {
      let videoDduration = isNaN(video.duration) ? 0 : video.duration

      setСurrentTime(prev => {
        // Save the previous time, we need while replaying after reconnection
        prev.handleReturnData().then(time => {
          videoPrevCurrentTimeRef.current = time
        })

        return {
          type: "UPDATE",
          payload: { currentTime: video.currentTime }
        }
      })

      if (watchPartyHostId === "modNotPresentVideo") {
        setСurrentTimeMNP({
          type: "UPDATE_CURRENT_TIME",
          payload: { currentTime: video.currentTime }
        })
      }
      const scalePos = isNaN(video.currentTime / videoDduration)
        ? 0
        : video.currentTime / videoDduration

      setValues([scalePos * 100])
      if (video.ended) {
        setPlayerProps({ paused: true })
      }

      let currentMinutes = Math.floor(video.currentTime / 60)
      let currentSeconds = Math.floor(video.currentTime - currentMinutes * 60)
      let durationMinutes = Math.floor(videoDduration / 60)
      let durationSeconds = Math.floor(videoDduration - durationMinutes * 60)

      if (currentTimeElement) {
        currentTimeElement.innerHTML = `${currentMinutes}:${
          currentSeconds < 10 ? "0" + currentSeconds : currentSeconds
        }`
      }

      if (durationTimeElement) {
        durationTimeElement.innerHTML = `${durationMinutes}:${
          durationSeconds < 10 ? "0" + durationSeconds : durationSeconds
        }`
      }

      if (
        !isLoop &&
        playerRef.current.currentTime > playerRef.current.duration - 0.3
      ) {
        // 0.3 is seconds before end.
        playerRef.current.pause()
      }

      if (
        isAutoPlayMNP &&
        video.currentTime > 1 &&
        watchPartyHostId === "modNotPresentVideo"
      ) {
        setAutoPlayMNP(false)
      }
    }

    // unmute the incomming audio, when
    // React.useEffect(() => {
    //   if (isModPresentVideo || isModPresentImage) {
    //     setWpLocalMuteControlProps({ value: false, enabled: false })
    //     setLocalMute(false)
    //     meetingClient?.rtc?.toggleWpLocalMuteControl({
    //       enabled: false,
    //       value: false
    //     })
    //     window.MeetOnline?.client().rtc?.toggleAllMuteUsers(false)
    //   }
    //   // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [isModPresentVideo, isModPresentImage])

    const handleMouseEnter = () => {
      setPlayerIsFocused(true)
      if (isEnabledToggleControlDesktop) {
        setPlayerProps({ isOpenControlDesktop: true })
      }
    }

    const handleMouseLeave = () => {
      setPlayerIsFocused(false)
      if (isEnabledToggleControlDesktop) {
        setPlayerProps({ isOpenControlDesktop: false })
      }
    }

    const handleStopPropogation = event => {
      event.stopPropagation()
    }

    const isNoBG = React.useMemo(() => {
      return (
        /* isNaN(video?.duration) || */
        isLandscape ||
        isAudioWatchParty ||
        (watchPartyHostId !== "modNotPresentImage" &&
          watchPartyHostId !== "modNotPresentOverlay" &&
          isLandscape)
      )
    }, [isAudioWatchParty, isLandscape, /*   */ watchPartyHostId])

    const stylesVideoPlayer: React.CSSProperties = React.useMemo(() => {
      const isMNP =
        watchPartyHostId === ModNotPresentType.IMAGE ||
        watchPartyHostId === ModNotPresentType.VIDEO ||
        watchPartyHostId === ModNotPresentType.OVERLAY

      if (isFullScreenMode?.active) {
        return {
          height: "100vh",
          width: "100vw",
          objectFit: isMNP ? "cover" : "contain",
          borderRadius: "0px",
          backgroundColor: isNoBG
            ? "transparent"
            : roomStyles?.alertBackgroundColor ?? "black"
        }
      } else {
        return {
          ...styling,
          objectFit: isMNP ? "cover" : "contain",
          borderRadius: "0px",
          backgroundColor: isNoBG
            ? "transparent"
            : roomStyles?.alertBackgroundColor ?? "black"
        }
      }
    }, [
      isNoBG,
      styling,
      roomStyles?.alertBackgroundColor,
      isFullScreenMode?.active,
      watchPartyHostId
    ])

    const isInformationOverlay = React.useMemo<boolean>(() => {
      return (
        !isOpen &&
        roomStyles?.enableModNotPresentOverlay &&
        (watchPartyHostId === "modNotPresentImage" ||
          watchPartyHostId === "modNotPresentVideo" ||
          watchPartyHostId === "modNotPresentOverlay")
      )
    }, [isOpen, roomStyles?.enableModNotPresentOverlay, watchPartyHostId])

    const isAutoPlay = React.useMemo<boolean>(() => {
      return (
        ((isAutoPlayMNP && !isEnabledAutoPlay) || enabledShoppableMNP) &&
        watchPartyHostId === "modNotPresentVideo"
      )
    }, [
      enabledShoppableMNP,
      isAutoPlayMNP,
      isEnabledAutoPlay,
      watchPartyHostId
    ])

    const [isFirstRender] = useRecoilState(layoutStates.firstRenderMobile)
    React.useEffect(() => {
      if (isFirstRender && watchPartyHostId === "modNotPresentVideo") {
        setPlayerProps({ isOpenControlsMobile: false })
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const source = React.useMemo(() => {
      if (isBase64) return wpSrc

      return !isDesktop || isIOSIpad
        ? `${
            enabledShoppableMNP && typeShoppableMNP === "play"
              ? srcShoppableMNP
              : wpSrc
          }?random=${uuidv4()}#t=0.1`
        : `${
            enabledShoppableMNP && typeShoppableMNP === "play"
              ? srcShoppableMNP
              : wpSrc
          }?random=${uuidv4()}`
    }, [
      enabledShoppableMNP,
      isDesktop,
      isIOSIpad,
      srcShoppableMNP,
      typeShoppableMNP,
      wpSrc,
      isBase64
    ])

    React.useEffect(() => {
      // if videoErrorRef.current is true, means video has fail due to network issue
      // So load the video when user is connected back
      if (
        connectionStatus === ConnectionStatus.CONNECTED &&
        videoErrorRef.current
      ) {
        // Load the video
        video.src = source
        video.load()
        video.currentTime = videoPrevCurrentTimeRef.current

        // Only play the video, if it was already playing
        if (!paused) video.play()

        // Clear the error
        videoErrorRef.current = false
      }

      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [connectionStatus, source])

    React.useEffect(() => {
      if (playerRef.current) playerRef.current.load()
    }, [source])

    React.useEffect(() => {
      setPlayerProps({ paused: false })
      if (playerRef.current) playerRef.current.play()
    }, [source])

    React.useEffect(() => {
      setSpinner(true)
    }, [enabledShoppableMNP, srcShoppableMNP, wpSrc])

    const handleTouchVideo = () => {
      if (isMobile || isTablet) {
        setPlayerIsFocused(!isPlayerFocused)
      }
    }

    const previousChat = useRecoilValue(previouslyPublishedChat)
    const updateChatById = useSetRecoilState(updateChatSelector)

    const unpublishChat = (previousChat: Partial<MessageModel>) => {
      updateChatById({
        ...previousChat,
        published: false,
        replyChats: previousChat.replyChats?.map(c => ({
          ...c,
          published: false
        }))
      })
    }

    const renderCloseIcon = () => {
      if (!isAvatarPopupActive) return null

      const handleOnClose = () => {
        toggleVideoPopup(false)
        stopWatchParty()
        if (previousChat) {
          unpublishChat(previousChat)
        }
      }

      return (
        <CircleCloseIcon
          id="close-video"
          onTouchStart={handleOnClose}
          onClick={handleOnClose}
          background="rgba(0, 0, 0, 0.2)"
          aria-label="circle-close-icon"
          position="absolute"
          top={"12px"}
          right={isMobile ? "8px" : "12px"}
          width={isMobile ? "28px" : "32px"}
          height={isMobile ? "28px" : "32px"}
          fontSize={isMobile ? "1.2rem" : "1.4rem"}
          _hover={{
            background: "rgba(0, 0, 0, 0.6)"
          }}
        />
      )
    }

    const showOnlyPlayButton =
      isFloatingDivActive &&
      // show play video if current user is watch party host or mod not present video is active
      (watchPartyHostId === localUserProperties.localUserId ||
        isModPresentVideo)

    const showDragToResizeIcon = isMobile && !isLandscape && !isTablet

    // show leave button on player controller, if UI is rendered on mobile or leave button should be displayed on RHS on desktop
    const showLeaveButton = (isMobile && !isTablet) || showLeaveButtonOnRHS

    // Show full player controls if MNP video or current user is a watch-party host user or is wp
    const showFullPlayerControls =
      watchPartyHostId === ModNotPresentType.VIDEO ||
      watchPartyHostId === localUserProperties.localUserId ||
      wpSrc

    // show live in player controller if user is not watch party host user and No MNP
    const showLiveController =
      watchPartyHostId !== localUserProperties.localUserId &&
      !checkIsModNotPresentId(watchPartyHostId)

    const isWatchPartyVideo =
      watchPartyHostId !== "modNotPresentImage" &&
      watchPartyHostId !== "modNotPresentOverlay"

    // hide the fullscreen icon on floating div and audio watch party
    const showFullScreenIcon = !isFloatingDivActive && !isAudioWatchParty

    return (
      <FullScreen
        className={
          isFullScreen
            ? "watchparty-fs"
            : isLandscape
            ? "watchpartyOuterLandscape"
            : "watchpartyOuter"
        }
        handle={isFullScreenMode}
      >
        {!isMobile && isModalBid && isFullScreenMode && isFullScreenMode && (
          <AuctionOverlayBid isMobile={false} />
        )}
        {!isMobile && isFinalModal && isFullScreenMode && isFullScreenMode && (
          <AuctionFinalOverlay />
        )}
        {showShareLinksModal && isFullScreenMode?.active && (
          <ShareLinksModal isTablet={true} isMobile={isMobile} />
        )}

        {renderCloseIcon()}

        <Flex
          flex={1}
          width={isFullScreenMode?.active ? "100%" : widthMainScreen ?? "100%"}
          height={"100%"}
          maxW={
            isFullScreenMode?.active || isFloatingDivActive
              ? "100%"
              : widthMainScreen && widthMainScreen
          }
          justifyContent="center"
          objectFit={"cover"}
          borderRadius={!(isMobile && !isTablet) && "0.375rem"}
          backgroundColor={
            isModPresentImage
              ? roomStyles?.alertBackgroundColor
              : "transparent !important"
          }
          pos="relative"
          onClick={toggleShowLeaveOverlay}
          onTouchStart={() => console.log("a")}
        >
          {header && header}
          {overlay && overlay}
          {isLogo && <LogoOverlay src={roomStyles?.logo} />}
          {isInformationOverlay && !isFloatingDivActive && (
            <InformationOverlay
              isTouchDelay={isTouchDelay}
              isMobile={isMobile}
              isSmallMainScreen={isSmallMainScreen}
              handleTouchStart={handleTouchStart}
              toggleShowLeaveOverlayTouchEnd={toggleShowLeaveOverlayTouchEnd}
              toggleShowLeaveOverlay={toggleShowLeaveOverlay}
            />
          )}
          {!isFloatingDivActive && (
            <div
              style={{
                position: "absolute",
                transform: isFullScreenMode?.active && "translate(0%, 50%)",
                bottom: isFullScreenMode?.active
                  ? "50%"
                  : isTablet || isMobile
                  ? isModPresentImage
                    ? "0px"
                    : "5px"
                  : isModPresentImage
                  ? "16px"
                  : "22px",
                left:
                  isTablet || isMobile
                    ? "0px"
                    : isModPresentImage
                    ? "0px"
                    : "2px",
                zIndex: 100000000
              }}
            >
              <ProductOverlay
                width={+widthMainScreen}
                height={maxHeightMainScreen}
                isWithoutTitle={isWithoutTitle}
              />
            </div>
          )}
          <VideoContainer
            style={
              isFullScreenMode?.active
                ? { height: "100vh", width: "100vw" }
                : styling
            }
            isBorderVideoPlayer={isBorderVideoPlayer}
            isLandscape={isLandscape}
            roomStyles={roomStyles}
            isMobile={isMobile}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            onTouchStart={handleTouchVideo}
          >
            {isWatchPartyVideo ? (
              <>
                {showFullScreenIcon && (
                  <Flex
                    pos="absolute"
                    right="0.75rem"
                    top="0.5rem"
                    zIndex="10000000000"
                  >
                    <FullScreenIcon
                      handleShowsFullScreen={handleShowFullScreen}
                      isFullScreen={isFullScreen || isFullScreenMode?.active}
                    />
                  </Flex>
                )}
                {/* {!isLivesellIframe && (!isOpen || !isFloatingDivActive) && (
                  <Flex pos="absolute" right="0.75rem" top="0.5rem">
                    <FullScreenIcon
                      handleShowsFullScreen={handleShowFullScreen}
                      isFullScreen={isFullScreen || isFullScreenMode?.active}
                    />
                  </Flex>
                )} */}
                {isActivePiP &&
                  !isAudioWatchParty &&
                  document.pictureInPictureEnabled && (
                    <PiPBgBox
                      coverImage={coverImage}
                      isMobile={isMobile}
                      isTouchDelay={isTouchDelay}
                      toggleShowLeaveOverlay={toggleShowLeaveOverlay}
                      toggleShowLeaveOverlayTouchEnd={
                        toggleShowLeaveOverlayTouchEnd
                      }
                      handleTouchStart={handleTouchStart}
                    />
                  )}

                {isSpinner && !hideSpinner && isVideo && (
                  <RainbowSpinner
                    zIndex="10000"
                    marginRight="-50%"
                    transform="translate(-50%, -50%)"
                    top="50%"
                    left="50%"
                  />
                )}

                {isSpinner && IS_ANDROID_NATIVE_APP && (
                  // Android webview doesn't support to set background color to video tag
                  // So display blank background color div on top of main window video while loading video.
                  <Box
                    position="absolute"
                    top="0px"
                    left="0px"
                    height="100%"
                    width="100%"
                    background={roomStyles?.alertBackgroundColor || "white"}
                    zIndex="9999"
                  />
                )}
                {isVideo ? (
                  <video
                    id="watchpartyvideoplayer"
                    onTimeUpdate={handleTimeUpdate}
                    ref={playerRef}
                    onLoadedData={() => setSpinner(false)}
                    onError={handleError}
                    preload="auto"
                    playsInline
                    autoPlay={isAutoPlay}
                    muted={
                      wpLocalMuteControlProps.enabled && !isLocalMuted
                        ? wpLocalMuteControlProps.value
                        : !checkIsModNotPresentId(watchPartyHostId) && !isHost
                        ? true
                        : isLocalMuted
                    }
                    height="100%"
                    controls={
                      isMobile && !isTablet ? false : isMobile && !isTablet
                    }
                    controlsList={"nodownload noremoteplayback noplaybackrate"}
                    disablePictureInPicture={false}
                    disableRemotePlayback={true}
                    loop={isLoop}
                    // src={source}
                    style={stylesVideoPlayer}
                    onClick={toggleShowLeaveOverlay}
                    onTouchStart={!isTouchDelay ? handleTouchStart : null}
                    onTouchEnd={
                      !isTouchDelay ? toggleShowLeaveOverlayTouchEnd : null
                    }
                  >
                    <source src={source} type="video/mp4"></source>
                  </video>
                ) : (
                  <img
                    src={source}
                    height="100%"
                    style={stylesVideoPlayer}
                    onClick={toggleShowLeaveOverlay}
                  />
                )}
                {isMobile &&
                  !isTablet &&
                  showFullscreenPlayerButtons &&
                  isWatchParty &&
                  watchPartyType !== "audio" &&
                  !isFloatingDivActive &&
                  isVideo && (
                    <div
                      style={{
                        position: "absolute",
                        top: "10px",
                        right: "0px",
                        zIndex: 10000
                      }}
                    >
                      <FullScreenPlayerControlButton
                        isMobile={true}
                        touchDelay={touchDelay}
                        playerRef={playerRef}
                        hideControls={hideControls}
                        isPanelFS={true}
                        watchPartyHostId={watchPartyHostId}
                        isTablet={isTablet}
                      />
                    </div>
                  )}
              </>
            ) : (
              <>
                <OverlayNoPresentImage
                  toggleShowLeaveOverlayTouchEnd={
                    toggleShowLeaveOverlayTouchEnd
                  }
                  handleTouchStart={handleTouchStart}
                  alertBackgroundColor={roomStyles?.alertBackgroundColor}
                  toggleShowLeaveOverlay={toggleShowLeaveOverlay}
                  wpSrc={wpSrc}
                  isMobile={isMobile}
                  isTouchDelay={isTouchDelay}
                  watchPartyHostId={watchPartyHostId}
                />
              </>
            )}
            <FloatingControlsCtx.Provider
              value={{
                values,
                handleOnChange,
                showThumb: isOpenControlsMobile || !isMobile,
                isOpen,
                isMobile: isMobile && !isTablet,
                isTablet,
                handleTouchStart,
                handleTouchEnd: toggleShowLeaveOverlay,
                handleClickVideo: toggleShowLeaveOverlay,
                styling: isFullScreenMode?.active
                  ? { height: "100vh", width: "100vw" }
                  : styling,
                isTouchDelay,
                isCustomPlayer: true,
                widthLeaveOverlay: isLandscape && widthLeaveOverlay,
                isMainMobileScreen: isMainMobileScreen,
                heightLeaveOverlay,
                offTouch: !isMobile,
                isTransparent: true,
                isLandscape,
                localUserProperties,
                isDesktop,
                changeSizeIconDependingHeightVideo,
                showLeaveButton: showLeaveButtonOnRHS,
                isVideo,
                paused,
                playVideo,
                pauseVideo,
                handleOnTouchEndPlay,
                handleOnTouchEndStop,
                handleOnTouchEndMute,
                handleOnMouseMove: handleOnMouseMoveVolume,
                isMuted,
                handleMute,
                isVolumeScale,
                localUserId: _localUserId,
                watchPartyHostId,
                isControlVolume,
                isOpenControlsMobile,
                isOpenControlDesktop,
                isPlayerFocused,
                showBarPlayer: showFullPlayerControls && isVideo,
                showDragToResizeIcon
              }}
            >
              <FloatingControls />
            </FloatingControlsCtx.Provider>
          </VideoContainer>
        </Flex>
      </FullScreen>
    )
  }
)
